import { ICON } from 'helpers/IconHelpers';
import { TeamModel } from 'types/Schedule.types';

// cSpell: disable
export const BASE_FB_STORAGE_URL = 'https://firebasestorage.googleapis.com/v0/b/squares-4fef3.firebasestorage.app/o/';
const L01 = 'squares-logos%2Fsquares-logo.webp?alt=media&token=792c0d9a-50bd-4647-9c37-3346b5090ffa';
const L11 = 'squares-logos%2Fsquares-logo-v11.webp?alt=media&token=ba11ac95-bc13-4f13-911b-571304936b7e';
const L12 = 'squares-logos%2Fsquares-logo-v12.webp?alt=media&token=b2244a51-9b94-49e5-be22-7d6b775844c3';
export const LOGO_01 = `${BASE_FB_STORAGE_URL}${L01}`;
export const LOGO_11 = `${BASE_FB_STORAGE_URL}${L11}`;
export const LOGO_12 = `${BASE_FB_STORAGE_URL}${L12}`;
const APP_SCREENSHOT = 'screenshots%2Fphone-screenshot-v1.webp?alt=media&token=9dc59187-e71d-4fe5-bffd-0b7e2635014a';
export const IPHONE_APP_SCREENSHOT = `${BASE_FB_STORAGE_URL}${APP_SCREENSHOT}`;

// cSpell: enable
export const ImageURL = {
  CoralReef: 'images/coral-reef.webp',
  AppBg: 'images/bg-distorted-mesh.webp',
  AppLogo: 'images/logo.webp',
};

export const AnimationCls = {
  CloseCard: 'swing-out-top-bck',
  OpenCard: 'swing-in-top-fwd',
};

export const patternsArray = [
  'absurdity',
  'assault',
  'blackOrchid',
  'creamPaper',
  'crissxcross',
  'cubes',
  'darkDenim',
  'fabricDark45Degree',
  'fabricOfSquares',
  'fakeBrick',
  'fakeLuxury',
  'grayLines',
  'greenFibers',
  'gridNoise',
  'groovePaper',
  'hexellence',
  'paper1',
  'purtyWood',
  'snow',
  'tex2res3',
  'tile3px',
  'waveGrid',
  'whiteBedSheet',
  'whiteBrushed',
  'whiteLeather',
  'whitePaperboard',
  'whiteWall',
  'whitey',
  'brickWallDark',
  'brickWall',
  'honeyImSubtle',
  'tileableWood',
  'darkWood',
  'retinaWood',
  'cartographer',
  'footballNoLines',
  'carbonFiber',
  'carbonFiberBig',
];
export const TOTAL_FRAME_PATTERNS = patternsArray.length;

// #region LOG COLOR STYLES ***************************************************

// cSpell:enableCompoundWords
// #region LOG COLORS
// dodgerblue     = #1E90FF;
// cornsilk       = #FFF8DC;
// darkolivegreen = #556B2F;
// palegreen      = #98FB98;
// darkgreen      = #006400;
// crimson        = #DC143C;
// ivory          = #FFFFF0;
// whitesmoke     = #F5F5F5;
//

export type ColorStyleClsType = {
  bg: string;
  color: string;
  weight?: number;
  style?: 'normal' | 'italic';
};

const baseStyle = 'padding: 0 2px; border: thin solid; border-radius: 40px; text-align: center;';

/**
 * Generates a custom CSS style for `console.log` color bubble
 * @param param `{ColorStyleClsType} { bg, color, weight, style }`
 * ```
 * export type ColorStyleClsType = {
 *  bg: string;
 *  color: string;
 *  weight?: number; // 100..900 default 400
 *  style?: 'normal' | 'italic'; // default 'normal'
 *  };
 *```
 * @returns {string} CSS style string that should be applied similar to
 * ```
 * const customStyle = getColorCls({bg: '#000000', color: '#FFFFFF', weight: 600, style: 'italic'});
 * console.log('some text %c highlight bubble %c', customStyle, '');
 * // the last "%c" gets assigned an empty quote to stop the style from expanding to the next console.log line
 * ```
 */
export const getColorCls = ({ bg, color, weight = 400, style = 'normal' }: ColorStyleClsType): string => {
  return `${baseStyle} background: ${bg}; border-color: ${bg};
          color: ${color}; font-weight: ${weight}; font-style: ${style};`;
};

const colorCls = (style: string) => {
  const bgColor = style.trim().slice(12, 20);
  return `${baseStyle} border-color: ${bgColor} ${style}`;
};

export const BurlywoodCls = colorCls('   background: #f0d8ba; color: #121212; font-weight: 700;');
export const DodgerBlueCls = colorCls('  background: #1e90ff; color: #fff8dc;');
export const InfoCls = colorCls('        background: #a9d4ff; color: #000000');
export const ArmyGreenCls = colorCls('   background: #556b2f; color: #fff4b7;');
export const PaleGreenCls = colorCls('   background: #98fb98; color: #000000;');
export const CrimsonCls = colorCls('     background: #dc143c; color: #fff8dc; font-weight: 700;');
export const CountDisplayCls = colorCls('background: #2a0077; color: #d3fffd;');
export const ValueCls = colorCls('       background: #ffa048; color: #000000;');
export const ValueLgCls = colorCls('     background: #ffa048; color: #000000; font-weight: 700; font-size: 14px;');
export const LocationCls = colorCls('    background: #ff4885; color: #ffffff;');
export const ActionCls = colorCls('      background: #4e48ff; color: #ffffff;');
export const DarkGrayCls = colorCls('    background: #333333; color: #fff8dc;');
export const DarkGreenCls = colorCls('   background: #006400; color: #fff8dc; font-style: italic;');
// #endregion

// #region EMOJI/CHARS NAMES
export const Emojis = {
  addPlayer: '♟',
  addScore: '⚔',
  admin: '⚗',
  asterisk: '🞿',
  cancel: '✘',
  checkBox: '✅',
  checkMark: '✔️',
  close: '🞬',
  delete: '🗑️',
  ex: '❌',
  exGrey: '✖️',
  eye: '👁️',
  eyes: '👀',
  fingerUp: '☝️',
  fingerDown: '👇',
  fingerLeft: '👈',
  fingerRight: '👉',
  fullWindow: '🗖',
  football: '🏈',
  gear: '⚙️',
  hammers: '⚒️',
  heartOn: '♥',
  heartOff: '♡',
  info: '🛈',
  lockBoard: '🗝',
  ok: '✔',
  options: '⏣', // '⌬', // ⚙️
  party: '🎉',
  pencil: '🖉',
  plus: '🞥',
  print: '⌨', //'🖨️',
  question: '❓',
  redBrick: '⛔️',
  rocket: '🚀',
  safety: '🛡',
  saveGame: '🖫',
  share: '☍',
  shieldOff: '⛉',
  shieldOn: '⛊',
  small: '▦',
  squares: '⧉',
  big: '▣',
  speak: '💬',
  target: '⯐',
  thumbsUp: '👍',
  transactionStart: '📃',
  transactionSuccess: '📑',
  transactionComplete: '📜',
  threeDots: '⠇',
  voiceAmp: '📣',
  warning: '⚠️',
  user: '👤',
};
// #endregion

export const PLAYER_ICONS = [
  ICON.Bee,
  ICON.Bolt,
  ICON.Boy,
  ICON.Cap,
  ICON.Chanel,
  ICON.Coffee,
  ICON.CrowdFire,
  ICON.Crown,
  ICON.Debug,
  ICON.Dollar,
  ICON.Dribble,
  ICON.Ghost,
  ICON.Gift,
  ICON.Girl,
  ICON.Glass,
  ICON.Globe,
  ICON.GlobeAlt,
  ICON.Pacman,
  ICON.Pill,
  ICON.Sun,
  ICON.Swiss,
  ICON.Terrain,
  ICON.Trophy,
  ICON.Umbrella,
  ICON.YinYang,
];

// '☭',
// 'bowl',
// '♛',
// '♠',
// '♣',
// '♥',
// '♦',
// '⚑',
// '⚒',
// '⛑',
// '✿',
// '🎖',
// '🎗',
// '🐿',
// '🕱',
// '🗡',
// '✪',
// ];

// #region NFL Teams **********************************************************

export const NFL_TEAM_NAMES: string[] = [
  'ARI',
  'ATL',
  'BAL',
  'BUF',
  'CAR',
  'CHI',
  'CIN',
  'CLE',
  'DAL',
  'DEN',
  'DET',
  'GB',
  'HOU',
  'IND',
  'JAX',
  'KC',
  'LAC',
  'LAR',
  'LV',
  'MIA',
  'MIN',
  'NE',
  'NO',
  'NYG',
  'NYJ',
  'PIT',
  'PHI',
  'SEA',
  'SF',
  'TB',
  'TEN',
  'WSH',
];

export const NFL_TEAMS: TeamModel[] = [
  {
    teamAbv: 'ARI',
    teamCity: 'Arizona',
    teamName: 'Cardinals',
    teamID: '1',
    division: 'West',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'ATL',
    teamCity: 'Atlanta',
    teamName: 'Falcons',
    teamID: '2',
    division: 'South',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'BAL',
    teamCity: 'Baltimore',
    teamName: 'Ravens',
    teamID: '3',
    division: 'North',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'BUF',
    teamCity: 'Buffalo',
    teamName: 'Bills',
    teamID: '4',
    division: 'East',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'CAR',
    teamCity: 'Carolina',
    teamName: 'Panthers',
    teamID: '5',
    division: 'South',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'CHI',
    teamCity: 'Chicago',
    teamName: 'Bears',
    teamID: '6',
    division: 'North',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'CIN',
    teamCity: 'Cincinnati',
    teamName: 'Bengals',
    teamID: '7',
    division: 'North',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'CLE',
    teamCity: 'Cleveland',
    teamName: 'Browns',
    teamID: '8',
    division: 'North',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'DAL',
    teamCity: 'Dallas',
    teamName: 'Cowboys',
    teamID: '9',
    division: 'East',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'DEN',
    teamCity: 'Denver',
    teamName: 'Broncos',
    teamID: '10',
    division: 'West',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'DET',
    teamCity: 'Detroit',
    teamName: 'Lions',
    teamID: '11',
    division: 'North',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'GB',
    teamCity: 'Green Bay',
    teamName: 'Packers',
    teamID: '12',
    division: 'North',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'HOU',
    teamCity: 'Houston',
    teamName: 'Texans',
    teamID: '13',
    division: 'South',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'IND',
    teamCity: 'Indianapolis',
    teamName: 'Colts',
    teamID: '14',
    division: 'South',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'JAX',
    teamCity: 'Jacksonville',
    teamName: 'Jaguars',
    teamID: '15',
    division: 'South',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'KC',
    teamCity: 'Kansas City',
    teamName: 'Chiefs',
    teamID: '16',
    division: 'West',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },

  {
    teamAbv: 'LV',
    teamCity: 'Las Vegas',
    teamName: 'Raiders',
    teamID: '17',
    division: 'West',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'LAC',
    teamCity: 'Los Angeles',
    teamName: 'Chargers',
    teamID: '18',
    division: 'West',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },

  {
    teamAbv: 'LAR',
    teamCity: 'Los Angeles',
    teamName: 'Rams',
    teamID: '19',
    division: 'West',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'MIA',
    teamCity: 'Miami',
    teamName: 'Dolphins',
    teamID: '20',
    division: 'East',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },

  {
    teamAbv: 'MIN',
    teamCity: 'Minnesota',
    teamName: 'Vikings',
    teamID: '21',
    division: 'North',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'NE',
    teamCity: 'New England',
    teamName: 'Patriots',
    teamID: '22',
    division: 'East',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'NO',
    teamCity: 'New Orleans',
    teamName: 'Saints',
    teamID: '23',
    division: 'South',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'NYG',
    teamCity: 'New York',
    teamName: 'Giants',
    teamID: '24',
    division: 'East',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'NYJ',
    teamCity: 'New York',
    teamName: 'Jets',
    teamID: '25',
    division: 'East',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'PIT',
    teamCity: 'Pittsburgh',
    teamName: 'Steelers',
    teamID: '26',
    division: 'North',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'PHI',
    teamCity: 'Philadelphia',
    teamName: 'Eagles',
    teamID: '27',
    division: 'East',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'SF',
    teamCity: 'San Francisco',
    teamName: '49ers',
    teamID: '28',
    division: 'West',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'SEA',
    teamCity: 'Seattle',
    teamName: 'Seahawks',
    teamID: '29',
    division: 'West',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'TB',
    teamCity: 'Tampa Bay',
    teamName: 'Buccaneers',
    teamID: '30',
    division: 'South',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'TEN',
    teamCity: 'Tennessee',
    teamName: 'Titans',
    teamID: '31',
    division: 'South',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'WSH',
    teamCity: 'Washington',
    teamName: 'Commanders',
    teamID: '32',
    division: 'East',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
];

// #endregion

export enum RulerType {
  SUB = 'SUB',
  ALC = 'ALC',
  STEEL = 'STEEL',
  PLAYOFF_LEADER = 'PLAYOFF_LEADER',
  PLAYOFF_WILDCARD = 'PLAYOFF_WILDCARD',
  PLAYOFF_HUNT = 'PLAYOFF_HUNT',
  CHART_LEGEND = 'CHART_LEGEND',
  MODAL_SEPARATOR = 'MODAL_SEPARATOR',
  MODAL_SEPARATOR_THIN = 'MODAL_SEPARATOR_THIN',
}
